<template>
    <div>
        <div class="serviceBox">
            <div class="serviceLabel">选择时间:</div>
            <timeSelecter @timeChanged="handleTimeChange" ref="myTimeSelecter" :dataflag="true"></timeSelecter>
        </div>
        <div class="serviceBox">
            <label class="serviceLabel" for="">服务提供方：</label>
            <a-select style="width: 120px" v-model="selectedAppcode" @change="handleSupplierChange" show-search allow-clear>
                <a-select-option v-for="(item,index) in appcodes" :key="index" :value="item">
                    {{item}}
                </a-select-option>
            </a-select>

            <label class="serviceLabel" for="" style="margin-left:10px;">服务消费方：</label>
            <a-select style="width: 120px" v-model="selectedInvokeappcode" show-search allow-clear>
                <a-select-option v-for="(item,index) in invokappcodes" :key="index" :value="item">
                    {{item}}
                </a-select-option>
            </a-select>

            <label class="serviceLabel" for="" style="margin-left:20px;width:50px;">IP：</label>
            <serviceIpSelecter :searchTimeRange="searchTimeRange" :selectedAppcode="selectedAppcode"
                :selectedInvokeappcode="selectedInvokeappcode" ref="myIPSelecter"
                @onIPChange="handleClientIpChange" style="width:300px;"></serviceIpSelecter>

        </div>
        <div class="serviceBox" v-if="logkey">
            <label class="serviceLabel" for="">报文关键字:</label>
            <a-input class="serviceInput" allow-clear  style="width:300px;" placeholder="请输入请求或响应报文关键字" v-model="logKeyWord" />
            
            <label class="serviceLabel" for="" style="margin-left:20px;width:80px;">traceid:</label>
            <a-input class="serviceInput" allow-clear  style="width:300px;" placeholder="traceid" v-model="logTraceid" />

        </div>
        <div class="serviceBox">
            <label class="serviceLabel" for="">服务&方法:</label>
            <serviceSelecter :searchTimeRange="searchTimeRange" :selectedAppcode="selectedAppcode"
                :selectedInvokeappcode="selectedInvokeappcode" :clientip="clientip" ref="myServiceSelecter"
                @onAppCodeChange="handleServiceKeyChange" style="width:700px;"></serviceSelecter>
            <a-button class="searchItem" type="primary" @click="handleSubmit">查询</a-button>

            <a-button class="searchItem" type="primary" @click="handleReset">重置</a-button>
        </div>
        <!-- <p style="width:100%;font-size:14px;margin-top:-15px;padding-left:100px;color:#e91e63;">
            需知：必须选择模糊匹配的结果查询!!!  输入三个以上字符模糊匹配 !!!  匹配范围受前三个条件限制 ！！！  
        </p> -->
    </div>
</template>
<script>

import timeSelecter from '../../monitorerror/logtimeselecter'
import serviceSelecter from './serviceselecter'
import serviceIpSelecter from './serviceIpSelecter.vue'

export default {
    data() {
        return {
            appcodes:[],
            invokappcodes:[],
            chartPerTime:'',
            servicekey:'',
            searchTimeRange:'',
            selectedAppcode:'',
            selectedInvokeappcode:'',
            logKeyWord:'',
            logTraceid:'',
            clientip:"",
            timeType:''
        };
    },
    methods: {
        setDefaultUrl(url_){
            this.$refs.myServiceSelecter.setDefaultValue(url_);
            this.handleSubmit();
        },
        handleClientIpChange(value){
            this.clientip = value;
        },
        handleServiceKeyChange(value){
            this.servicekey = value;
            this.G.getServiceConsumApps(this.selectedAppcode,this.searchTimeRange.split('~')[0],this.searchTimeRange.split('~')[1],this,this.servicekey)
        },
        handleTimeChange(timeRange,timeType){//ttype
            this.searchTimeRange = timeRange;
            this.timeType = timeType
            switch (timeType) {
                case 11:
                    //每小时
                    this.chartPerTime = '1小时'
                    break;
                case 9:
                    //每小时
                    this.chartPerTime = '5分钟'
                    break;
                case 10:
                    //每15分钟
                    this.chartPerTime = '1分钟'
                    break;
                case 8:
                    //5分钟
                    this.chartPerTime = '1分钟'
                    break;
                case 7:
                    //1分钟
                    this.chartPerTime = '1秒'
                    break;
                default:
                    this.chartPerTime = '1分钟'
                    break;
            }
        },
        getDefaultSearch(){
            if(this.appcodes.length == 0){
                this.message.info("抱歉，您没有任何app的授权，请联系架构部授权系统");
                return
            }
            let monitorDetail = localStorage.getItem("monitorserviceDetailSearch");
            if(monitorDetail){
                monitorDetail = JSON.parse(monitorDetail);
                this.servicekey = monitorDetail.servicekey;
                this.selectedAppcode = monitorDetail.selectedAppcode;
                this.selectedInvokeappcode = monitorDetail.selectedInvokeappcode;
                this.logKeyWord = monitorDetail.logKeyWord;
                this.logTraceid = monitorDetail.logTraceid;
                this.clientip = monitorDetail.clientip;
            }
            else{
                this.servicekey = undefined;
                this.selectedAppcode = this.appcodes[0];
                this.selectedInvokeappcode = '';
                this.logKeyWord = '';
                this.logTraceid = monitorDetail.logTraceid;
                this.clientip = "";

            }
            //路由参数优先
            let query = this.$route.query;
            if(query.appcode){
                this.selectedAppcode = query.appcode 
                this.selectedInvokeappcode = ''
            }
            if(query.serviceconfig){
                this.servicekey = query.serviceconfig
            }

     
            this.$refs.myIPSelecter.setDefaultValue(this.clientip);

            this.$refs.myServiceSelecter.setDefaultValue(this.servicekey);
            this.handleSupplierChange()
        },
        handleReset(){
            localStorage.setItem("monitorserviceDetailSearch",'');
            this.$refs.myTimeSelecter.getCachedData();
            this.getDefaultSearch();
            this.handleSubmit();
        },
        handleSubmit(){

            if(this.appcodes.length == 0){
                this.message.info("抱歉，您没有任何app的授权，请联系架构部授权系统");
                return
            }
            
            const {searchTimeRange,servicekey,chartPerTime,selectedAppcode,selectedInvokeappcode,logKeyWord,logTraceid,timeType,clientip} = this;
            let SearchKeys = {searchTimeRange,servicekey,chartPerTime,selectedAppcode,selectedInvokeappcode,logKeyWord,logTraceid,timeType,clientip}
            localStorage.setItem("monitorserviceDetailSearch",JSON.stringify(SearchKeys));
            this.$emit("searcchChange",SearchKeys)
        },
        handleSupplierChange(){
            this.G.getServiceConsumApps(this.selectedAppcode,this.searchTimeRange.split('~')[0],this.searchTimeRange.split('~')[1],this,this.servicekey)
        }
    },
    props:{
        logkey:Boolean
    },
    components:{
        timeSelecter,
        serviceSelecter,
        serviceIpSelecter
    },
    mounted(){
        this.appcodes = this.G.getAllAppcodes(this);
        
        this.getDefaultSearch();
        this.handleSubmit();
        //获得默认服务提供方和消费方

    }
};
</script>
<style scoped>
    .serviceBox{
        display: flex;
        margin-bottom: 20px;
    }
    .serviceLabel{
        display: inline-flex;
        width:100px;
        line-height: 32px;
    }
    .serviceInput{
        display: inline-flex;
        width:calc(100% - 100px);
    }
    .searchItem{
        margin-left: 20px;
    }
</style>
